import { render, staticRenderFns } from "./document-form.vue?vue&type=template&id=66a32af2&scoped=true"
import script from "./document-form.vue?vue&type=script&lang=js"
export * from "./document-form.vue?vue&type=script&lang=js"
import style0 from "./document-form.vue?vue&type=style&index=0&id=66a32af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a32af2",
  null
  
)

export default component.exports